import { HTTP_STATUS } from "@/constants/polling.constants";
import { store } from "@/store";
import { setPollingError, setPollingSuccess } from '@/store/slices/ui/UISlice';
import type { Meta } from '@/types/polling.types'; // if you have this type; otherwise use Record

/**
 * Utility helper to check for retryable status codes.
 */
export function isRetryableStatus(status: number): boolean {
  return (
    status === HTTP_STATUS.TOO_MANY_REQUESTS ||
    (status >= HTTP_STATUS.INTERNAL_SERVER_ERROR_MIN &&
      status <= HTTP_STATUS.INTERNAL_SERVER_ERROR_MAX)
  );
}

/** Small helper to produce paragraphs if you need them elsewhere */
export function paragraphsFrom(message: string, meta?: Meta): string[] {
  const paragraphs: string[] = [message];
  if ((meta != null) && typeof (meta).status === 'string') {
    paragraphs.push(`Status: ${(meta).status}`);
  }
  return paragraphs;
}

/**
 * SERVICE-SAFE: Imperative dispatchers for non-React modules (PollingClient, utils).
 * These use the store directly and are safe to call from anywhere (not hooks).
 */
export function dispatchPollingError(title: string, message: string, meta?: Meta) {
  store.dispatch(
    setPollingError({
      title,
      message,
      details: (meta) ?? null,
    })
  );
}

export function dispatchPollingSuccess(title: string, message: string, resourceUrl?: string | null, meta?: Meta) {
  store.dispatch(
    setPollingSuccess({
      title,
      message,
      resourceUrl: resourceUrl ?? null,
    })
  );
}
